import { Typography } from "@repo/design-system";

export function Publications() {
  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-1">
        <Typography as="h2" variant="heading-3" className="text-contentPrimary">
          Publications
        </Typography>
      </div>
      <div className="flex flex-col gap-3 ">
        <Typography
          variant="paragraph-l-regular"
          className="text-contentPrimary">
          Here we will add our paper citation once it is published. We will also
          include all citations to our paper, as well as citations to the
          original publications from which data submitted to our database are
          derived.
        </Typography>
      </div>
    </div>
  );
}
